export const API_URL = 'https://www.powerlego.com/ApiGateway/';
export const SIDEBYSIDE_API_URL = 'https://bb0xg7o51l.execute-api.us-east-2.amazonaws.com/beta';
export const ACC_KEY = 'c346b9eb4d8f1161d01cf7c88e66c181';

export const GOOGLE_API_KEY = 'AIzaSyCsreMGj8xStaCAs9V2HjMizheuJaVlII0';